import { RootState } from 'types'

export default function reduce(state: RootState['articleMeta'] = {}, { type, payload }: any): RootState['articleMeta'] {
  switch (type) {
    case 'ARTICLE_META_SET': {
      return { ...state, [payload.id]: payload }
    }
    case 'ARTICLE_META_UPSERT': {
      return {
        ...state,
        [payload.id]: {
          ...state[payload.id],
          ...payload,
        },
      }
    }
    default:
      return state
  }
}
